import React from "react";
import { useTranslation } from "react-i18next";

function ReferralAccountsModal({ accounts }) {
  const { t } = useTranslation();
  return (
    <>
      <div
        className="modal fade"
        id="refferal-accounts"
        role="dialog"
        aria-labelledby="refferal-accountsLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog"
          role="document"
          style={{ 
            top: "25%", 
            padding: 0,
            borderRadius: "16px",
          }}
        >
          <div
            className="modal-content"
            style={{
              borderRadius: "16px",
              overflow: "hidden",
            }}
          >
            <div className="modal-header">
              <h5 className="modal-title" id="refferal-accountsLabel">
                {t("Accounts")}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {accounts.join(", ")}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReferralAccountsModal;